export default "__VITE_ASSET__BCV83oVe__"